<script setup lang="ts">
import Customfooter from "~/@core/components/footer-certificate.vue";
</script>

<template>
  <component :is="Customfooter"></component>
</template>
